const DAY_MS = 24 * 60 * 60 * 1000;
const HAS_TIME_ZONE = /(?:Z|[+-]\d{2}:?\d{2})$/i;
const ISO_DATE_TIME = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/;

const parseUtcDate = (value) => {
  if (value instanceof Date) return value;

  const text = String(value ?? '').trim();
  if (!text) return null;

  const normalized = ISO_DATE_TIME.test(text) && !HAS_TIME_ZONE.test(text)
    ? `${text.replace(' ', 'T')}Z`
    : text;
  const date = new Date(normalized);

  return Number.isNaN(date.getTime()) ? null : date;
};

const pad = (value) => String(value).padStart(2, '0');

export const formatUtcDateTime = (value, { includeYear = false } = {}) => {
  const date = parseUtcDate(value);
  if (!date) return value ? String(value) : '—';

  const day = pad(date.getUTCDate());
  const month = pad(date.getUTCMonth() + 1);
  const year = includeYear ? `.${date.getUTCFullYear()}` : '';
  const time = `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`;

  return `${day}.${month}${year} ${time} UTC`;
};

export const utcDateKey = (value = new Date()) => new Date(value).toISOString().slice(0, 10);

export const utcDateKeyDaysAgo = (days, now = Date.now()) =>
  utcDateKey(now - Number(days || 0) * DAY_MS);
